import React from 'react';
import './style.scss';

/**
 * Divider component - used in multiple places.
 *
 * @returns {JSX.Element} The Divider component.
 * @example
 *  <Divider />
 */
function Divider() {
    return (
        <hr className="page__divider" />
    );
}

export default Divider;